module.exports = __webpack_public_path__ + "static/media/headshot.15a2dfbe.jpeg";